import { useState } from 'react';
import CouponManager from '../features/coupons/CouponManager';
import OrderTypeDiscountManager from '../features/coupons/OrderTypeDiscountManager';
import BannerManager from '../features/banners/BannerManager';

export default function CouponsPage() {
  const [activeTab, setActiveTab] = useState<'coupons' | 'order_discounts' | 'banners'>('coupons');

  return (
    <div className="page">
      <header className="page-header">
        <div>
          <h1>Kupon ve İndirimler</h1>
          <p>Kupon kodlarını, sipariş tipi indirimlerini ve reklam bannerlarını buradan yönetin.</p>
        </div>
      </header>
      <div className="tab-switch">
        <button
          type="button"
          className={`tab-button ${activeTab === 'coupons' ? 'active' : ''}`}
          onClick={() => setActiveTab('coupons')}
        >
          Kuponlar
        </button>
        <button
          type="button"
          className={`tab-button ${activeTab === 'order_discounts' ? 'active' : ''}`}
          onClick={() => setActiveTab('order_discounts')}
        >
          Sipariş tipi indirimleri
        </button>
        <button
          type="button"
          className={`tab-button ${activeTab === 'banners' ? 'active' : ''}`}
          onClick={() => setActiveTab('banners')}
        >
          Reklam yöneticisi
        </button>
      </div>
      {activeTab === 'coupons' ? (
        <section className="page-section">
          <CouponManager />
        </section>
      ) : activeTab === 'order_discounts' ? (
        <section className="page-section">
          <OrderTypeDiscountManager />
        </section>
      ) : (
        <section className="page-section">
          <BannerManager />
        </section>
      )}
    </div>
  );
}
